import React from 'react';
import './ConversationList.css';

const ConversationList = ({ conversations, currentConversationId, onSelectConversation, onNewConversation }) => {
  return (
    <div className="ConversationList">
      <button className="NewChatButton" onClick={onNewConversation}>
        + New Chat
      </button>
      <div className="Conversations">
        {conversations.length === 0 ? (
          <div className="EmptyState">
            <p>No conversations yet</p>
            <p className="EmptyStateHint">Start a new chat to begin</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <div
              key={conv.id}
              className={`ConversationItem ${conv.id === currentConversationId ? 'active' : ''}`}
              onClick={() => onSelectConversation(conv.id)}
            >
              <div className="ConversationTitle">{conv.title || 'New Conversation'}</div>
              <div className="ConversationPreview">{conv.preview || 'New conversation'}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationList;

